<section translate="no">
  <section style="height: auto;">
    <nav>
        <ol class="cd-breadcrumb custom-separator">
            <table>
                <tbody>
                    <tr>
                        <td class="nomeTela">
                          Cadastrado de Orgão
                        </td>
                    </tr>
                </tbody>
            </table>
        </ol>
    </nav>
</section>
  <main translate="no">
    <section class="main-section div_orientacao">

      <form class="form-class" data-toggle="collapse">
        <input type="text" class="form-control" id="id" name="id" [(ngModel)]="novoItem.id" required
          style="display: none;">
        <div class="form-div p-3">
          <label for="codigo" class="form-label">Codigo</label>
          <input type="number" class="form-control" id="codigo" name="codigo" [(ngModel)]="novoItem.codigo" required>
        </div>
        <div class="form-div p-3">
          <label for="codigoCentralizado" class="form-label">Codigo Centralizado</label>
          <input type="text" class="form-control" id="codigoCentralizado" name="codigoCentralizado"
            [(ngModel)]="novoItem.codigoCentralizado" required>
        </div>
        <div class="form-div p-3">
          <label for="descricao" class="form-label">Descrição</label>
          <input type="text" class="form-control" id="descricao" name="descricao" [(ngModel)]="novoItem.descricao"
            required>
          <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
        </div>
        <div class="form-div p-3">
          <label for="nomeApresentacao" class="form-label">Nome de Apresentação</label>
          <input type="text" class="form-control" id="nomeApresentacao" name="nomeApresentacao" [(ngModel)]="novoItem.nomeApresentacao"
            required>
          <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
        </div>

        <div class="form-div p-3" style=" padding-left: 56px !important; display: flex;">
          <div class="form-div form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.ordenacaoOrgao"
              name="ordenacaoOrgao" id="ordenacaoOrgao">
            <label class="form-check-label" for="flexCheckDefault">
              Esse orgão tera ordenação ? <span matTooltip="selecionar se o orgão precisar ser ordenado na lista que aparece no Dashboard"><i
                  class="fas fa-question-circle"></i></span>
            </label>
          </div>

        </div>



        <div class="div-button mb-3 p-3">
          <a style="margin-right: 10px;" [routerLink]="['/orgao-listagem']"><button id="class-button" class="btn btn-secondary">Voltar</button></a>
          <button id="class-button" style="margin-right: 10px;" (click)="Limpar()" class="btn btn-secondary">Limpar</button>
          <button id="class-button" (click)="submitForm()" class="btn btn-primary">Salvar</button>
        </div>

        

      </form>

    </section>
  </main>
</section>